function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { initScrollableTableWithinRichText } from '../../../src/js/utilities/tables';
var ENTRY_LIST = '[data-component="entryList"]';
var IS_OPENED_CLASS = 'is-opened';
var ARIA_EXPANDED = 'aria-expanded';
var ARIA_HIDDEN = 'aria-hidden';
var EntryList = /*#__PURE__*/function () {
  function EntryList(list) {
    var _this = this;
    _classCallCheck(this, EntryList);
    this.list = list;
    this.togglers = Array.from(this.list.querySelectorAll('[data-element="entryListItemToggler"]'));
    this.togglers.forEach(function (toggler) {
      toggler.addEventListener('click', function () {
        return _this.toggleItem(toggler);
      });
    });
    this.openActiveToggler();
    window.addEventListener('hashchange', function () {
      _this.openActiveToggler();
    });
    initScrollableTableWithinRichText(list);
  }
  return _createClass(EntryList, [{
    key: "getHsh",
    value: function getHsh() {
      return decodeURIComponent(window.location.hash.substring(1));
    }
  }, {
    key: "isActiveToggler",
    value: function isActiveToggler(toggler) {
      var _toggler$parentNode;
      return this.getHsh() === (toggler === null || toggler === void 0 || (_toggler$parentNode = toggler.parentNode) === null || _toggler$parentNode === void 0 ? void 0 : _toggler$parentNode.id);
    }
  }, {
    key: "openActiveToggler",
    value: function openActiveToggler() {
      var _iterator = _createForOfIteratorHelper(this.togglers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (this.isActiveToggler(item)) {
            this.toggleItem(item);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "closeItem",
    value: function closeItem(data) {
      data.item.classList.remove(IS_OPENED_CLASS);
      data.button.setAttribute(ARIA_EXPANDED, false);
      data.content.setAttribute(ARIA_HIDDEN, true);
      history.pushState({}, null, '#');
    }
  }, {
    key: "openItem",
    value: function openItem(data) {
      data.item.classList.add(IS_OPENED_CLASS);
      data.button.setAttribute(ARIA_EXPANDED, true);
      data.content.setAttribute(ARIA_HIDDEN, false);
      history.pushState({}, null, "#".concat(data.item.id));
    }
  }, {
    key: "toggleItem",
    value: function toggleItem(elm) {
      var listItem = elm.parentNode;
      var listItemContent = listItem.querySelector('[data-element="entryListContent"]');
      var data = {
        button: elm,
        item: listItem,
        content: listItemContent
      };
      if (listItem.matches(".".concat(IS_OPENED_CLASS))) {
        this.closeItem(data);
      } else {
        this.openItem(data);
      }
    }
  }]);
}();
Array.from(document.querySelectorAll(ENTRY_LIST)).forEach(function (entryList) {
  new EntryList(entryList);
});